export const defaultQuotes = [
    `I don't have a walk-in closet, but I do have a walk-on closet on my floor`,
    `Fire downtown! 🚒 🔥 \navoid the roads, it's a total \nlockdown `,
    `New ice cream shop on Main St. \ngiving away free ice cream all \nweek! 🍦`
]

export const defaultLocations =[
    "Oslo",
    "Münich",
    "Madrid",
    "Rome",
    "Miami",
    "Cannes",
    "Beijing",
    "Berlin",
    "Paris",
    "São Paulo",
    "Nairobi",
    "Addis Ababa",
    "Moscow",
    "Istanbul",
    "Shanghai",
    "Sapporo"
]

export const defaultChannels = [
    "Main",
    "Politics",
    "repost",
    "Questions",
    "Students",
    "food",
    "askwomen",
    "askmen"
]

export const defaultColors = {
    "lightOrange": "#FF9908",
    "selectiveYellow": "#FFBA00",
    "lightRed": "#DD5F5F",
    "blueGreen": "#8ABDB0",
    "pacificBlue": "#06A3CB",
    "lightGreen": "#9EC41C"
}

export const defaultHashtags = [
"#love",
"#happy",
"#yolo",
"#cute",
"#summer",
"#fun"
]